module.exports = __webpack_public_path__ + "static/media/CN_escudo.64076bcd.png";